import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { animationFrameScheduler, Observable, Subscription } from 'rxjs';
import { CircleArrowButtonComponent } from 'src/app/components/buttons/circle-arrow-button/circle-arrow-button.component';
import { CareerPlanSkill, CareerPlanSkillDetail } from 'src/app/models/career-plans';
import { CareerPlansApiService } from 'src/app/services/api/career-plans-api.service';
import { CareerPlansService } from 'src/app/services/career-plans.service';
import { CareerPlansFacade } from '../../../../state/career-plans/career-plans.facade';
import { buildProgressAnimation } from '../../../../_shared/animations/progress-animation';

const easeOutQuad = (x: number): number => x * (2 - x);

@Component({
  selector: 'app-skill-card',
  templateUrl: './skill-card.component.html',
  styleUrls: ['./skill-card.component.scss']
})
export class SkillCardComponent implements OnInit, OnDestroy {
  private static readonly COUNT_ANIM_DURATION = 1500;
  count$: Observable<number>;

  @ViewChild(CircleArrowButtonComponent) unfoldButton!: CircleArrowButtonComponent;
  unfolded = false;

  @Input()
  skill: CareerPlanSkill;

  @Output()
  skillDetail = new EventEmitter<CareerPlanSkillDetail>();

  subscriptions: Subscription[] = [];

  constructor(
    private careerPlansApiService: CareerPlansApiService,
    private careerPlansService: CareerPlansService,
    private readonly careerPlansFacade: CareerPlansFacade,
  ) {}

  ngOnInit() {
    if (this.careerPlansFacade.selectedSkill?.skillId === this.skill.skillId) {
      this.unfolded = true;
      this.toggleSkillUnfold(false);
    }

    this.subscriptions.push(
      this.careerPlansService.getSkillUnrolledObs().subscribe((unrolledSkill) => {
        if (unrolledSkill.skillId !== this.skill.skillId) {
          if (this.unfolded) {
            this.unfolded = false;
          }
        }
      })
    );

    this.initCountAnimation();
  }

  toggleSkillUnfold(force?: boolean) {
    const unfolded = force ?? this.unfolded;

    if (!unfolded) {
      const subscription = this.careerPlansApiService.getSkillDetail(this.skill.skillId).subscribe((response) => {
        this.skillDetail.emit(response);
        this.unfolded = true;
        this.careerPlansFacade.setSkill(this.skill);
        this.careerPlansService.notifySkillUnrolled(this.skill);
        subscription.unsubscribe();
      });
    } else {
      this.unfolded = false;
      this.careerPlansFacade.setSkill(undefined);
      this.skillDetail.emit(null);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subs) => subs.unsubscribe());
  }

  initCountAnimation(): void {
    const count = this.skill.progress;
    const startTime = animationFrameScheduler.now();

    this.count$ = this.count$ = buildProgressAnimation(count, startTime, SkillCardComponent.COUNT_ANIM_DURATION);
  }
}
